const $ = window.jQuery;
const TFORALSIMULATIONPUBLICRPC = window.TFORALSIMULATIONPUBLICRPC;

const get = (simulation) => {
    return new Promise((resolve, reject) => {
        let payload = {
            'action': 'tf_oral_simulation_public_rpc_request',
            'security': TFORALSIMULATIONPUBLICRPC.security,
            'method': 'get',
            'params': {
                simulation: simulation
            }
        };
        fetch(TFORALSIMULATIONPUBLICRPC.ajax_url, {
            method: "post",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Accept': 'application/json'
            },
            body: $.param(payload),
            credentials: 'same-origin',
        }).then(res => res.json()).then((data) => {
            resolve(data);
        });
    })

};


export {get};
